import { Box, Divider, Tag, Text } from '@factorialco/deprecated-design-system'
import { Carousel } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { WorkSpace } from 'modules/space_control/hooks/useWorkSpace'

interface Props {
  workSpace: WorkSpace
}
const SidepanelInfo = ({ workSpace }: Props) => {
  return (
    <Box>
      {workSpace.images.length > 0 && (
        <Carousel columns={{ default: 1 }} showArrows showDots>
          {workSpace.images.map((image, idx) => (
            <img
              key={idx}
              src={image.url}
              style={{ height: 150, width: 300, objectFit: 'cover' }}
            />
          ))}
        </Carousel>
      )}
      <Text.Header2>{workSpace.name}</Text.Header2>
      <Box paddingTop="s8">
        <Text.Normal color="grey800" weight="normal">
          {workSpace.description}
        </Text.Normal>
      </Box>
      <Box gap="s4" paddingTop="s16">
        <Text.Normal color="grey800" weight="normal" size="200">
          {workSpace.workArea?.name}
        </Text.Normal>
        <Text.Normal color="grey800" weight="normal" size="200">
          {i18n.t('space_control.overview.booking_sidepanel.schedule_info', {
            start_time: workSpace.startTime,
            end_time: workSpace.endTime,
          })}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" gap="s64" paddingBottom="s32" paddingTop="s24">
        <Box gap="s4">
          <Text.Normal ellipsis color="grey800" weight="normal" size="200">
            {i18n.t('space_control.overview.booking_sidepanel.type_info')}
          </Text.Normal>
          <Tag type="grey">{workSpace.workSpaceTypeName}</Tag>
        </Box>
        <Box gap="s4">
          <Text.Normal ellipsis color="grey800" weight="normal" size="200">
            {i18n.t('space_control.overview.booking_sidepanel.capacity_info')}
          </Text.Normal>
          <Text.Normal ellipsis color="grey800" weight="normal">
            {i18n.t('space_control.overview.booking_sidepanel.people_count', {
              capacity: workSpace.capacity,
            })}
          </Text.Normal>
        </Box>
      </Box>
      <Divider />
    </Box>
  )
}

export default observer(SidepanelInfo)
